import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as RegionActions from '../../actions/master-data/region.actions';

@Injectable()
export class RegionEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {}

  loadRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.loadRegions),
      mergeMap(() =>
        this.masterDataService.getAllRegions().pipe(
          map((regions) => RegionActions.loadRegionsSuccess({ regions })),
          catchError((error) => {
            let errorMessage = 'An error occurred loading regions.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(RegionActions.loadRegionsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  addRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.addRegion),
      mergeMap(({ region }) =>
        this.masterDataService.addNewRegion(region).pipe(
          mergeMap(saved => [            
            RegionActions.addRegionSuccess({
              region: saved,
              message: 'Region created successfully'
            }),
            RegionActions.loadRegions()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the region';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(RegionActions.loadRegionsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.updateRegion),
      mergeMap(({ region }) =>
        this.masterDataService.updateRegion(region).pipe(
          mergeMap(saved => [            
            RegionActions.updateRegionSuccess({
              region: saved,
              message: 'Region updated successfully'
            }),
            RegionActions.loadRegions()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while editing the region';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(RegionActions.loadRegionsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );  

  deleteRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.deleteRegion),
      mergeMap(({ id }) =>
        this.masterDataService.deleteRegion(id).pipe(
          mergeMap(saved => [            
            RegionActions.deleteRegionSuccess({
              message: 'Region deleted successfully'
            }),
            RegionActions.loadRegions()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while deleting the region';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(RegionActions.loadRegionsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}